module.exports = __webpack_public_path__ + "a1ff222a3c8648c3f9c1268c1fd9d1fd.fbx";